import { render } from "./HowGoldieWorks.vue?vue&type=template&id=733bb5bb"
import script from "./HowGoldieWorks.vue?vue&type=script&lang=js"
export * from "./HowGoldieWorks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__